export const QUERIES = {
  CODE: 'code',
  ORIGINAL_PATH: 'originalPath',
};

export const USERNAME_COOKIE_KEY = 'username';

export const COOKIE_KEYS = {
  audioRoomToken: 'audioRoomToken',
};

export const ALERT_LIFETIME = 6000;
export const MAX_ALERTS = 3;

export const LINE_BREAK = '\n';
export const ATTRIBUTES = {
  HREF: 'href',
  DOWNLOAD: 'download',
};

export const TAGS = {
  A: 'a',
};

export const BACKGROUND_PRESETS = [
  'v1615110548/15879138916140_zgjk6z.jpg',
  'bg.0c0d8acb_egc7mv.jpg',
  'v1615113668/tree_mm3ewn.webp',
  'v1615114028/95bQSF_q97014.jpg',
  'v1615116150/523452345_zwdwmu.png',
  '15614987449380_vllmkt.jpg',
];

export const TRAILER_MIN_SIZE = {
  width: 400,
  height: 250,
};

export const YOUTUBE_API_KEYS = [
  'AIzaSyCVPinFlGHMn0uzeWFjNTA38QOZBejOlSs',
  'AIzaSyD0WjHt1tEIzdYLWSbcArCXTdBbDvyxDMk',
  'AIzaSyAbkUdit9z4zGiSmXtYAuBoJYKMDeZ6rSM',
];

export enum LocalStorage {
  SaveConfig = 'saveConfig',
}
